import { useQuery } from '@apollo/client'
import type {
  LeaderGroupNode,
  UnresolvedLeaderGroupsQuery} from '@/modules/companies';
import {
  ALL_LEADER_GROUPS,
  USER_LEADER_GROUPS,
} from '@/modules/companies'
import { useNodes } from './useNodes'
import { useMemo } from 'react'

export const useUserLeaderGroups = (userId: string, isAdmin: boolean) => {
  const query = isAdmin ? ALL_LEADER_GROUPS : USER_LEADER_GROUPS
  const { data, loading: groupsLoading } = useQuery(query)

  const unresolvedData = data as UnresolvedLeaderGroupsQuery | undefined

  const allGroups = useNodes<LeaderGroupNode>(
    isAdmin ? unresolvedData?.allLeaderGroups : unresolvedData?.userLeaderGroups
  )

  const { myLeaderGroups, defaultLeaderGroup, hasAccess } = useMemo(() => {
    if (isAdmin) {
      return {
        myLeaderGroups: allGroups,
        defaultLeaderGroup: allGroups[0] ?? null,
        hasAccess: true,
      }
    }

    const meLeaderGroups = allGroups.filter(group =>
      group.leaders.some(leader => leader.id === userId)
    )

    return {
      myLeaderGroups: allGroups,
      defaultLeaderGroup: meLeaderGroups[0] ?? null,
      hasAccess: meLeaderGroups.length > 0,
    }
  }, [isAdmin, allGroups, userId])

  return { hasAccess, myLeaderGroups, defaultLeaderGroup, groupsLoading }
}
